import React, { useEffect, useMemo, useState } from 'react';
import { Modal, Button, Form, Radio, Checkbox, Bubble } from 'tea-component';
import './index.scss';
import { useIntl } from 'umi';
import BubbleCommon, {
  separateReviewsRatingTips,
  separateByCountryPCTips,
  separateByCountryConsoleTips,
  separateByCountryMobileTips,
  TipsMapType,
} from '../../BubbleCommon';

const separateByCountryTipsMap: { [key: string]: TipsMapType } = {
  pc: separateByCountryPCTips,
  console: separateByCountryConsoleTips,
  mobile: separateByCountryMobileTips,
};

const defaultCalculationMethod = {
  'Channel Settings': 'Aggregated',
  'Sentiment Settings': 'Aggregated',
  // 'Net Sentiment Settings': 'Aggregated',
  'Language Settings': 'Aggregated',
  // 'Topic Setting': 'Aggregated',
  'Country Settings': 'Aggregated',
  'Time Settings': 'Aggregated',
  'Rating Settings': 'Aggregated',
  'Platform Settings': 'Aggregated',
};

const defaultSelectMetric: any = [];

export default function Download({
  visible,
  setVisible,
  download,
  gameInfo,
  showList,
  selectMetric = defaultSelectMetric,
  calculationMethod = defaultCalculationMethod,
  className,
  confirmLoading,
}: any) {
  // console.log('gameInfo', gameInfo);

  const { formatMessage } = useIntl();

  // mobile,pc,console
  useEffect(() => {
    setVisible(visible);
  }, [visible]);

  const close = () => setVisible?.(false);

  const confirm = () => {
    // 数据处理

    const result = {
      metrics: params.Metrics,
      accumulation: {
        by_date:
          params['Calculation Method']['Time Settings'] === 'Separate by Time',
        by_country:
          params['Calculation Method']['Country Settings'] ===
          'Separate by Country',
        by_channel:
          params['Calculation Method']['Channel Settings'] ===
          'Separate by Channel',
        by_language:
          params['Calculation Method']['Language Settings'] ===
          'Separate by Language',
        by_sentiment:
          params['Calculation Method']['Sentiment Settings'] ===
          'Separate by Sentiment',
        // by_net_sentiment:
        //   params['Calculation Method']['Net Sentiment Settings'] ===
        //   'Separate by Net Sentiment',
        by_rating:
          params['Calculation Method']['Rating Settings'] ===
          'Separate by Reviews Rating',
        by_platform:
          params['Calculation Method']['Platform Settings'] ===
          'Separate by Platform',
      },
    };

    console.log('confirm result', result);

    download?.(result);
  };

  const cancel = () => {
    setVisible?.(false);
  };

  const [params, setParams] = useState<{
    Metrics: string[];
    'Calculation Method': {
      [key: string]: string;
    };
    'File Format': string;
  }>({
    Metrics: selectMetric,
    'Calculation Method': calculationMethod,
    'File Format': 'Excel',
  });

  useEffect(() => {
    setParams({
      Metrics: selectMetric,
      'Calculation Method': calculationMethod,
      'File Format': 'Excel',
    });
  }, [gameInfo, selectMetric, calculationMethod]);

  const addByRating =
    gameInfo.entity_type === 'mobile'
      ? {
          label: 'Rating Settings',
          list: [
            {
              text: 'Aggregated',
              value: 'Aggregated',
            },
            {
              text: 'Separate by Reviews Rating',
              value: 'Separate by Reviews Rating',
            },
          ],
        }
      : null;

  // const addByPlatform =
  //   gameInfo.entity_type === 'console'
  //     ? {
  //         label: 'Platform Settings',
  //         list: [
  //           {
  //             text: 'Aggregated',
  //             value: 'Aggregated',
  //           },
  //           {
  //             text: 'Separate by Platform',
  //             value: 'Separate by Platform',
  //           },
  //         ],
  //       }
  //     : null;

  const list = useMemo(() => {
    const defaultList = [
      {
        label: 'Metrics',
        type: 'checkbox',
        list: [
          {
            text: 'Mentions',
            value: 'Mentions',
          },
          {
            text: 'Account Post',
            value: 'Account Post',
          },
          {
            text: 'Engagement',
            value: 'Engagement',
          },
          {
            text: 'Brand Health',
            value: 'Brand Health',
          },
          {
            text: 'Sentiment',
            value: 'Sentiment',
          },
          {
            text: 'Non Negative%',
            value: 'Non Negative%',
          },
          {
            text: 'User Score',
            value: 'User Score',
          },
        ],
      },
      {
        label: 'Calculation Method',
        type: 'radioGroup',
        list: [
          {
            label: 'Time Settings',
            list: [
              {
                text: 'Aggregated',
                value: 'Aggregated',
              },
              {
                text: 'Separate by Time',
                value: 'Separate by Time',
              },
            ],
          },
          {
            label: 'Channel Settings',
            list: [
              {
                text: 'Aggregated',
                value: 'Aggregated',
              },
              {
                text: 'Separate by Channel',
                value: 'Separate by Channel',
              },
            ],
          },
          // {
          //   label: 'Net Sentiment Settings',
          //   list: [
          //     {
          //       text: 'Aggregated',
          //       value: 'Aggregated',
          //     },
          //     {
          //       text: 'Separate by Net Sentiment',
          //       value: 'Separate by Net Sentiment',
          //     },
          //   ],
          // },
          {
            label: 'Sentiment Settings',
            list: [
              {
                text: 'Aggregated',
                value: 'Aggregated',
              },
              {
                text: 'Separate by Sentiment',
                value: 'Separate by Sentiment',
              },
            ],
          },
          {
            label: 'Language Settings',
            list: [
              {
                text: 'Aggregated',
                value: 'Aggregated',
              },
              {
                text: 'Separate by Language',
                value: 'Separate by Language',
              },
            ],
          },
          // {
          //   label: 'Topic Setting',
          //   list: [
          //     {
          //       text: 'Aggregated',
          //       value: 'Aggregated',
          //     },
          //     {
          //       text: 'Separate by Topic',
          //       value: 'Separate by Topic',
          //     },
          //   ],
          // },
          {
            label: 'Country Settings',
            list: [
              {
                text: 'Aggregated',
                value: 'Aggregated',
              },
              // {
              //   text: 'Separate by Region',
              //   value: 'Separate by Region',
              // },
              {
                text: 'Separate by Country',
                value: 'Separate by Country',
              },
            ],
          },

          addByRating,
          // addByPlatform,
        ],
      },
      // {
      //   label: 'File Format',
      //   type: 'radio',
      //   list: [
      //     {
      //       text: 'Excel',
      //       value: 'Excel',
      //     },
      //     {
      //       text: 'CSV',
      //       value: 'CSV',
      //     },
      //   ],
      // },
    ];

    return showList || defaultList;
  }, [showList, gameInfo]);

  const hasUserScore = () => params.Metrics?.includes('User Score');

  const handleChange = (label, value) => {
    console.log('handleChange', label, value);

    const curParams = {
      ...params,
      [label]: value,
    };

    if (
      label === 'Metrics' &&
      value?.includes('User Score') &&
      !params?.Metrics?.includes('User Score')
    ) {
      curParams['Calculation Method']['Channel Settings'] =
        'Separate by Channel';

      if (gameInfo.entity_type === 'mobile') {
        curParams['Calculation Method']['Country Settings'] =
          'Separate by Country';
        curParams['Calculation Method']['Language Settings'] = 'Aggregated';
        curParams['Calculation Method']['Rating Settings'] = 'Aggregated';
      }

      if (gameInfo.entity_type === 'console') {
        curParams['Calculation Method']['Platform Settings'] =
          'Separate by Platform';
      }
    }

    setParams(curParams);
  };

  const handleGroupChange = (labelGroup, label, value) => {
    console.log('handleGroupChange', labelGroup, label, value);
    setParams({
      ...params,
      [labelGroup]: {
        ...params[labelGroup],
        [label]: value,
      },
    });
  };

  const disables = (item) =>
    (hasUserScore() && item.text === 'Separate by Language') ||
    (hasUserScore() && item.text === 'Separate by Reviews Rating') ||
    (gameInfo.entity_type !== 'mobile' &&
      item.text === 'Separate by Reviews Rating');
  const tooltip = (item) => {
    if (hasUserScore() && item.text === 'Separate by Language') {
      const { entity_type } = gameInfo || { entity_type: 'mobile' };
      return separateByCountryTipsMap[entity_type];
    }
    if (hasUserScore() && item.text === 'Separate by Reviews Rating')
      return separateReviewsRatingTips;

    return null;
  };

  return (
    <>
      <Modal
        visible={visible}
        size="l"
        caption={formatMessage({ id: 'Download Settings' })}
        className={`dbo-model-download ${className}`}
        onClose={close}
      >
        <Modal.Body>
          <Form className="teaui-form-alignment">
            {list?.map((item) => (
              <Form.Item
                label={formatMessage({ id: item.label })}
                key={item.label}
                className={`${
                  item.type.includes('Group') ? 'dbo-form-top-18' : ''
                }`}
              >
                {item.type === 'radio' && (
                  <Radio.Group
                    value={params[item.label]}
                    onChange={(value) => {
                      handleChange(item.label, value);
                    }}
                  >
                    {item.list?.map((item1) => (
                      <Radio key={item1.value} name={item1.value}>
                        {formatMessage({ id: item1.message || item1.text })}
                      </Radio>
                    ))}
                  </Radio.Group>
                )}

                {item.type === 'checkbox' && (
                  <Checkbox.Group
                    value={params[item.label]}
                    onChange={(value) => {
                      handleChange(item.label, value);
                    }}
                  >
                    {item.list?.map((item1) => (
                      <Checkbox
                        key={item1.value}
                        name={item1.value}
                        className="dbo-model-download-check"
                      >
                        {formatMessage({ id: item1.message || item1.text })}
                      </Checkbox>
                    ))}
                  </Checkbox.Group>
                )}

                {item.type.includes('Group') && (
                  <Form>
                    {item.list?.map(
                      (item1) =>
                        item1 && (
                          <Form.Item
                            label={formatMessage({ id: item1.label })}
                            key={item1.label}
                          >
                            {item.type === 'checkboxGroup' && (
                              <Checkbox.Group
                                value={params[item.label][item1.label]}
                                onChange={(value) => {
                                  handleGroupChange(
                                    item.label,
                                    item1.label,
                                    value,
                                  );
                                }}
                              >
                                {item1.list?.map((item2) => (
                                  <Checkbox
                                    name={item2.value}
                                    key={item2.value}
                                  >
                                    {formatMessage({ id: item2.text })}
                                  </Checkbox>
                                ))}
                              </Checkbox.Group>
                            )}

                            {item.type === 'radioGroup' && (
                              <Radio.Group
                                value={params[item.label][item1.label]}
                                onChange={(value) => {
                                  handleGroupChange(
                                    item.label,
                                    item1.label,
                                    value,
                                  );
                                }}
                              >
                                {item1.list?.map(
                                  (item2) =>
                                    item2 && (
                                      <Radio
                                        key={item2.value}
                                        name={item2.value}
                                        disabled={disables(item2)}
                                      >
                                        <BubbleCommon
                                          showIcon={false}
                                          tipsMap={tooltip(item2)}
                                        >
                                          {formatMessage({ id: item2.text })}
                                        </BubbleCommon>
                                      </Radio>
                                    ),
                                )}
                              </Radio.Group>
                            )}
                          </Form.Item>
                        ),
                    )}
                  </Form>
                )}
              </Form.Item>
            ))}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Bubble
            closeOnScroll
            content={
              params.Metrics.length === 0
                ? formatMessage({ id: 'Please select a metric' })
                : ''
            }
            placement="top"
            dark
          >
            <Button
              type="primary"
              loading={confirmLoading}
              onClick={confirm}
              disabled={params.Metrics.length === 0}
            >
              {formatMessage({ id: 'Confirm' })}
            </Button>
          </Bubble>

          <Button type="weak" onClick={cancel}>
            {formatMessage({ id: 'Cancel' })}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
